import React, { FC, FormEvent, useEffect, useState } from "react";
import {
  DatePicker,
  Label,
  MaskedTextField,
  mergeStyleSets,
  Stack,
  Modal,
  PrimaryButton,
  DefaultButton,
  IconButton,
  getTheme,
  MessageBar,
  MessageBarType
} from "@fluentui/react";
import moment from "moment";
import "./dashboard.css";
import { AiOutlineArrowRight,AiOutlineArrowLeft } from "react-icons/ai";
import { FaBullhorn } from "react-icons/fa";

type Props = {
  onClose(): void;
};

const classes = mergeStyleSets({
  container: {
    width: 600,
    height: 640,
    borderRadius: 8,
  },
  header: {
    alignItems: "center",
    padding:"16px 24px",
    display: "flex",
    flex: "1 1 auto",
    borderBottom:"1px solid #E5E5E5",
},
footer: {
    marginTop: 15,
    display: "flex",
    flexDirecton:'row',
    padding:"16px 24px",
    justifyContent: "space-between",
    borderTop:"1px solid #E5E5E5",
  },
    data:{
        padding:24,
        height:480,
        display:'flex',
        overflowY:"auto",
        flexDirection:"column",
    },
    tempImg:{
        height:240,
        width:'100%',
        borderRadius:4,
        marginBottom:24,
        backgroundColor:"#e5e5e5",
    },
    title: {
        fontSize: 18,
        lineHeight: 23,
        marginBottom:24,
        fontWeight: 500,
        color: "#525252",
        alignItems: "center",
        letterSpacing: "0.0015em",
    },
    description: {
        fontSize: 14,
        lineHeight: 23,
        marginBottom:24,
        fontWeight: 400,
        color: "#525252",
        alignItems: "center",
        whiteSpace:"pre-wrap",
    },
});
const theme = getTheme();
const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px"
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};
const iconButtonBoxedStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    borderRadius:4,
    border:"1px solid #e5e5e5",
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
};

const AnnouncementModal: FC<Props> = (props: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [ page, setPage ] = useState(0);
  const data = [
    {
        img:"https://s3-alpha-sig.figma.com/img/b4e4/4eb9/c3509c65cf471f32cf7a4b4925ef6503?Expires=1742169600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=A4PETIyqylVy6f94AY9VUOwnr~z340C8-a4HYDe~FkPUoAPuBBPAtzeecacISU2viJtE~YRcbSAUsZnUxPivgBOCbDtujQxSGS8qDtSTB9-IuzZqlhIsx-9hWkg-Sr4GyfSPNjmDu2qCES0Af9twwvUq~uKmG2Dx9fzyc8Rz1t2aXYpiKITaJ32q3w3jX3K7G~jwZUGxoD4bWY-AyjxDAIjubY8AwL3sMJc3klH9EkihkyqvwDz1Fqi~poWKM97MULW64tF7B4-DQZJxPpE0dn3-UNOqwoo5N464ghk8h09PzuQk0pe~dZINro0Hybxif2xPj5tTfo0TVl93etiZjg__",
        title:"Scheduled Maintenance Notice: Terminal Downtime",
        desc:"Please be advised that our terminal will be undergoing scheduled maintenance on March 20 from 8:00AM to 9:00AM CST.\nDuring this period, access to the terminal will be temporarily unavailable.\nWe apologize for any inconvenience this may cause and appreciate your understanding as we work to improve our services.\n\nThank you for your patience and support. If you have any questions, please feel free to reach out to our support team at support@qadworks.com."
    },
    {
        img:"https://s3-alpha-sig.figma.com/img/a275/e48c/a40ae30b66f3f548e058f0cd30165b2e?Expires=1742169600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=pqRWBhOQnDN7H5HEn1bKHZoARxXN97maoP21A1Ip6WstSgM7afbRD8RiW0G5plHLmK~o0kPiZXE0CFg4ONiPZkp3m3KYir9JqpaB~tDNB4-WHiYQPUeMElC9jxu-WMxwAr099UqOF35x3WFtW9AL56AMNvKGOyscu3qgGcn0n0TLJV4fLHuScPPfh3PomjfavnCPCyKOs6L2WYB1Ysel~I77M~FqtiW9Ya86qA9VE2XkWV4xt58WljrGLBZ63xX1LXLv8aKe1RuAqYabhWPKfeZVMth5br4kheplX5iVzoRZvsc~zN-gh7U4OJ8Ao9wzWiWW8c0j8Nbksq0D7IGJYQ__",
        title:"System Maintenance",
        desc:"Please be informed that our system will undergo scheduled maintenance on March 15 from 11:00PM to 1:00AM CST. During this time, some services may be temporarily unavailable or experience interruptions.\n\nWe recommend planning accordingly and apologize for any inconvenience this may cause. Our team is working diligently to improve our services and ensure the best possible experience."
    },
  ]

  return (
    <Modal
      titleAriaId="title"
      isOpen={true}
      onDismiss={props.onClose}
      isBlocking={false}
      containerClassName={classes.container}
    >
        <div className={classes.header}>
          <h6><FaBullhorn style={{marginRight:10}}/> Announcement</h6>
          <IconButton
            id="btn-close"
            styles={iconButtonStyles}
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup modal"
            onClick={props.onClose}
            disabled={isLoading}
          />
        </div>
        <div className={classes.data}>
            <img src={data[page].img} className={classes.tempImg}/>
            <h6 className={classes.title}>{data[page].title}</h6>
            <p className={classes.description}>{data[page].desc}</p>
        </div>
        <div className={classes.footer}>
          <IconButton
            id="arrow-left"
            styles={iconButtonBoxedStyles}
            iconProps={{ iconName: "Back" }}
            ariaLabel="previous"
            onClick={()=>setPage(page===0 ? page : page-1)}
            disabled={isLoading}
          />
          <p>{page+1}/{data?.length}</p>
          <IconButton
            id="arrow-right"
            styles={iconButtonBoxedStyles}
            iconProps={{ iconName: "Forward" }}
            ariaLabel="next"
            onClick={()=>setPage(page===(data?.length-1) ? page : page+1)}
            disabled={isLoading}
          />
        </div>
    </Modal>
  );
};

export default AnnouncementModal;
